import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import store from './Redux/Store';
import {Provider  } from "react-redux";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
<GoogleOAuthProvider clientId="727402678683-aa8t3ulirnm09u4a85lh7onpjdepakof.apps.googleusercontent.com">
<React.StrictMode>
   <Provider store={store}>
     <App/>
   </Provider>
  </React.StrictMode>
</GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
